import { myEmail } from './siteData';
import {NBSP}  from './helpers';

const homeData = [

    {
        type: 'plax',
        tint: 'shade-m',
        img: 'images/img-6.jpg',
        alt: 'grayscale image, close up of a developers hands at the typing on a laptop computer',
        imgPos: true,
        cont:
            [
                {
                    hed: "Hello. I'm" + NBSP + "Ray" + NBSP + "Messina,",
                    sub: "Full Stack Web Developer and" + NBSP + "Designer.",
                    hedClass: 'text-center ',
                    subClass: 'text-center sub-large',
                },
                {
                    colClass: 'text-center text-md-left',
                    btnClass: 'text-center text-md-left',

                    cont: "I am passionate about building engaging, dynamic, and scalable websites and applications. I invite you to take a look at my projects, review my résumé and contact me about how I can help you achieve your business" + NBSP + "goals.",

                    btns: [
                        {
                            text: "View My Projects",
                            url: "/projects"
                        },
                        {
                            text: "Contact Me",
                            url: "mailto:" + myEmail
                        }

                    ]
                }

            ]

    },
    {

        type: "side",
        head: "I am a designer who codes and a coder who" + NBSP + "designs.",
        text: "<p class='pt-1'>Having a balanced mix of technical and creative abilities, I apply both sides of my brain when deriving solutions. After working in the marketing sector as an art director, I decided to transition into coding. I have a Full Stack Web and Mobile Development Certification from <a href='http://nucamp.co' target='_blank' rel='noreferrer' >NuCamp</a>. Most recently, I earned a certification in C#/.NET and am ready to tackle new" + NBSP + "challenges.</p>",
        clname: "py-5",

    },

    {
        type: 'plax',
        tint: 'shade',
        img: 'images/img-9.jpg',
        alt: 'close up of UI design sketches strewn on desk; laptop, mobile phone, and pen off to the side',
        imgPos: true,
        cont:
            [
                {
                    sub: "Solving problems and turning ideas to reality.",
                    colClass: 'text-center  ',
                    btnClass: 'text-center ',
                    cont: "I love creating beautiful websites and apps that have a positive impact. I am always open to discussing new projects, creative ideas, or opportunities to be part of your vision. Get in touch and let me know how I" + NBSP + "can" + NBSP + "help.",
                    btns: [
                        {
                            text: "Let's Build Something Together",
                            url: "mailto:" + myEmail
                        }

                    ]
                }

            ]

    },

    {
        type: "top",
        head: "MERN and LAMP stacks, served with syrup and experience on" + NBSP + "the" + NBSP +"side.",
        text: "Just in case you were wondering what's under the hood. I specialize in MERN and LAMP stacks. JavaScript, PHP, CSS, Python and SQL are among my go-to tools. I'm also a lifelong learner who enjoys picking up new technologies, digging into unfamiliar problems, and figuring out how all the pieces fit together. After years of building software, I've learned that good engineering is about more than knowing the latest tools. It's about choosing the right ones, understanding the tradeoffs, and building systems that can" + NBSP + "scale" + NBSP + "successfully.",
        clname: "py-5"
    },
    {
        type: "deck",
        grid: { xs: '6', sm: '4', md: '3', lg: '2' },
        ogrid: { lg: '10' },
        clname: "skill-grid justify-content-center",
        cont: [
            {
                head: "React",
                text: null,
                icon: "fab fa-react",
            },
            {
                head: "Redux",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "cib:redux",
                    'data-inline': "false"
                }
            },
            {
                head: "NodeJS",
                text: null,
                icon: "fab fa-node-js",
            },
            {
                head: "ExpressJS",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "simple-icons:express",
                    'data-inline': "false"
                }
            },
            {
                head: "Javascript",
                text: null,
                icon: "fab fa-js",
            },
            {
                head: "PHP",
                text: null,
                icon: "fab fa-php",
            },
            {
                head: "Python",
                text: null,
                icon: "fab fa-python",
            },
            {
                head: "Typescript",
                text: null,
                icon: "fab fa-typescript",
            },
            {
                head: "MySQL",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "whh:mysqltwo",
                    'data-inline': "false"
                }
            },
            {
                head: "MongoDB",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "simple-icons:mongodb",
                    'data-inline': "false"
                }
            },
            {
                head: "PostgreSQL",
                text: null,
                icon: "iconify",
                attrs:{
                    'data-icon': "cib:postgresql",
                    'data-inline': "false"
                }
            },
            {
                head: "Bootstrap",
                text: null,
                icon: "fab fa-bootstrap",
            },
            {
                head: "MaterialUI",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "devicon-plain:materialui",
                    'data-inline': "false"
                }
             },
            {
                head: "WordPress",
                text: null,
                icon: "fab fa-wordpress",
            },
            {
                head: "C#",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "bxl:c-sharp",
                    'data-inline': "false"
                }
            },
            {
                head: "Docker",
                text: null,
                icon: "iconify",
                attrs: {
                    'data-icon': "cib:docker",
                    'data-inline': "false"
                }
            },    
            {
                head: "CSS3",
                text: null,
                icon: "fab fa-css3-alt",
            },
            {
                head: "HTML5",
                text: null,
                icon: "fab fa-html5",
            },
        ]
    },



];

export default homeData;